<template>
    <transition name="layout-fade">
        <v-layout wrap column class="layout-add layout-add--max_width">
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Новый пользователь</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs6>
                            <v-subheader class="pa-0">Имя</v-subheader>
                            <v-text-field
                                ref="name"
                                v-model="user.name"
                                v-validate="'required'"
                                data-vv-name="name"
                                :error-messages="errors.collect('name')"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs6>
                            <v-subheader class="pa-0">E-mail</v-subheader>
                            <v-text-field
                                ref="email"
                                v-model="user.email"
                                v-validate="'required|email'"
                                data-vv-name="email"
                                :error-messages="errors.collect('email')"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs6>
                            <v-subheader class="pa-0">Роль</v-subheader>
                            <v-select
                                :items="roles"
                                item-value="key"
                                item-text="value"
                                v-model="user.role_id"
                                single-line
                                text
                                solo/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs6>
                            <v-subheader class="pa-0">Пароль</v-subheader>
                            <v-text-field
                                ref="password"
                                v-model="user.password"
                                v-validate="'required|min:7'"
                                data-vv-name="password"
                                type="password"
                                :error-messages="errors.collect('password')"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs6>
                            <v-subheader class="pa-0">Повторите пароль</v-subheader>
                            <v-text-field
                                v-model="user.password_confirmation"
                                v-validate="'required|confirmed:password|min:7'"
                                data-vv-name="password_confirmation"
                                type="password"
                                :error-messages="errors.collect('password_confirmation')"
                                single-line
                                text
                                solo
                                required/>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import User from '../../../api/user'

    export default {
        name: 'addUser',
        $_veeValidate: {
            validator: 'new'
        },
        data: () => ({
            loading: false,
            roles: [
                {
                    key: 2,
                    value: 'Модератор'
                },
                {
                    key: 3,
                    value: 'Менеджер'
                },
                {
                    key: 4,
                    value: 'СММ'
                },
                {
                    key: 5,
                    value: 'Руководитель'
                },
            ],
            user: {
                name: '',
                role_id: 2,
                email: '',
                password: '',
            },
            dictionary: {
                custom: {
                    name: {
                        required: 'Имя не введено'
                    },
                    email: {
                        required: 'Почта не введено',
                        email: 'Формат не верный'
                    },
                    password: {
                        required: 'Пароль не введен',
                        min: 'Минимальная длина пароли 7 символов'
                    },
                    password_confirmation: {
                        required: 'Повторно пароль не введен',
                        confirmed: 'Пароли не совпадают',
                        min: 'Минимальная длина пароли 7 символов'
                    }
                }
            }
        }),
        mounted () {
            this.$validator.localize('ru', this.dictionary)
        },
        methods: {
            sendForm () {
                this
                    .$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true

                        User
                            .create(this.user)
                            .then(response => {
                                this.$store.commit('storeUser', response.data.data)
                                this.$store.commit('showSnackbar', {
                                    text: 'Успех! Пользователь добавлен',
                                    color: 'success'
                                })
                                this.$router.push({ name: 'userRoot' })
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            }
        }
    }
</script>
